<div [ngClass]="{'alert-danger': !confirmationSuccess, 'alert-success': confirmationSuccess}" class="alert bottom">
  <button type="button" class="close" aria-label="Close" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>

  <h4 *ngIf="confirmationTitle">
    {{confirmationTitle}}
  </h4>
  <p *ngIf="confirmationMessage">
    {{confirmationMessage}}
  </p>
</div>
